import { CustomLink } from '@/components/custom-link/CustomLink';
import { useVersionListAndSelectedName } from '@/hooks/useVersionListAndSelectedName';
import { Dropdown } from 'aui';
import { FoxIconDownSm } from 'aui-biz-icons';
import clsx from 'clsx';
import type React from 'react';

export type VersionSelectProps = {
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
};

export function VersionSelect(props: VersionSelectProps) {
  const { className, onClick } = props;

  const { currentName, versionList } = useVersionListAndSelectedName() ?? {};
  if (!versionList?.length) {
    return null;
  }

  return (
    <Dropdown
      menu={{
        items: versionList.map((x) => {
          return {
            key: x.id,
            disabled: x.disabled,
            label: (
              <CustomLink
                to={x.to}
                className={clsx('flex items-center gap-2', {
                  ['text-primary']: x.selected,
                })}
                onClick={onClick}
              >
                <span className="block max-w-[200px] truncate" title={x.name}>
                  {x.name}
                </span>
              </CustomLink>
            ),
          };
        }),
      }}
      trigger={['click']}
    >
      <div
        className={clsx(
          'flex flex-shrink-0 cursor-pointer items-center rounded-lg px-2 py-1 text-base font-400 leading-lg text-input hover:bg-btn-text-hover',
          className,
        )}
      >
        {currentName}

        <FoxIconDownSm size={14} className="ml-2 text-input-icon" />

        <ul className="hidden">
          {versionList.map((x) => {
            return (
              <li key={`${x.id}`} className={clsx(x.selected && 'selected')}>
                <CustomLink to={x.to}>{x.name}</CustomLink>
              </li>
            );
          })}
        </ul>
      </div>
    </Dropdown>
  );
}
